/**
 * Detect if running on the agency admin subdomain (admin.*)
 * vs the client SEO dashboard (app.* or anything else).
 */
export function isAgencyAdmin() {
  const host = window.location.hostname;
  return host.startsWith("admin.");
}

export function getAppMode() {
  return isAgencyAdmin() ? "agency" : "client";
}
